import styled from "styled-components";

export const Popup = styled.div`
  width: 420px;
  padding: 28px 28px 24px;
  box-sizing: border-box;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 700;
    line-height: normal;
  }

  > img {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
`;

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 20px;
  border-radius: 12px;
  background: #ecf0f3;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  > .label {
    color: #666;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    flex-shrink: 0;
  }

  > .value {
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    word-break: break-all;
  }
`;

export const QuantitySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 22px;

  > .label {
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
  }

  > input {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    outline: none;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    color: #121212;
    text-align: right;

    &:focus {
      border-color: #7f25fb;
    }
  }
`;

export const Divider = styled.div`
  margin: 20px 0;
  width: 100%;
  border-top: 1px dashed #d9d9d9;
`;

export const SummaryRow = styled.div<{ $highlight?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  > .label {
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
  }

  > .value {
    color: ${({ $highlight }) => ($highlight ? "#ff0000" : "#121212")};
    font-family: Pretendard;
    font-size: 15px;
    font-weight: ${({ $highlight }) => ($highlight ? 700 : 600)};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 16px;

  > .cancel {
    min-width: 72px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7f25fb;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  > .confirm {
    min-width: 88px;
    height: 42px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #7f25fb;
    color: #fff;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-sizing: border-box;

    &.disabled {
      background: #c4a0fd;
      color: #fff;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
`;
